//FIX ORDER
import slimscroll from "jquery-slimscroll";

import SmoothScroll from 'smooth-scroll';
import SwaggerUI from 'swagger-ui';

import "swagger-ui/dist/swagger-ui.css";


window.myapp_config = require("../template/src/js/_config/app.config.js");
window.myapp_get_color = require("../template/src/js/_get/app.get.colors.js");

window.initApp = require("../template/src/js/_modules/app.init.js");


require("../template/src/js/_modules/app.domReady.js");
require("../template/src/js/_modules/app.orientationchange.js");
require("../template/src/js/_modules/app.resize.trigger.js");
require("../template/src/js/_modules/app.scroll.trigger.js");
require("../template/src/js/_modules/app.window.load.js");
require("../template/src/js/_modules/app.navigation.js");


if(document.getElementById("home_api") != null) {
    SwaggerUI({
        dom_id: '#home_api',
        url: 'https://api.imcagro.com/docs/api-docs.json'
    })
}
